var render = function () {
  var _vm$data$filter, _vm$data$filter2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "root",
    staticClass: "catalog-page p"
  }, [_c('div', {
    staticClass: "catalog-page__filter"
  }, [_c('div', {
    staticClass: "catalog-page__filter-wrapper"
  }, [_c('div', {
    staticClass: "catalog-page__filter-content"
  }, [(_vm$data$filter = _vm.data.filter) !== null && _vm$data$filter !== void 0 && _vm$data$filter.main.list.length ? _c('CatalogFilter', {
    staticClass: "catalog-page__catalog-filter",
    attrs: {
      "list": _vm.data.filter.main.list,
      "value": _vm.data.filter.main.value,
      "loading": _vm.loading
    },
    on: {
      "change": function ($event) {
        return _vm.onFilterChange($event, true);
      },
      "reset": _vm.resetFilter,
      "submit": function ($event) {
        return _vm.emit('change-query', $event);
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm$data$filter2 = _vm.data.filter) !== null && _vm$data$filter2 !== void 0 && _vm$data$filter2.main.list.length ? _c('FilterModal', {
    attrs: {
      "list": _vm.data.filter.main.list,
      "value": _vm.data.filter.main.value,
      "loading": _vm.loading,
      "show": _vm.activeFilterModal
    },
    on: {
      "close": function ($event) {
        _vm.activeFilterModal = false;
      },
      "submit": function ($event) {
        return _vm.debounceChange($event, true);
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "catalog-page__header"
  }, [_vm.data.banner ? _c('CatalogWideBanner', {
    staticClass: "mb-20",
    attrs: {
      "link": ("/sales/" + (_vm.data.banner.code) + "/"),
      "src": _vm.data.banner.src.desk,
      "alt": _vm.data.banner.name
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.emitter.emit('banner-select', {
          banner: _vm.data.banner
        });
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.data.breadcrumb ? _c('Breadcrumb', {
    attrs: {
      "list": _vm.data.breadcrumb
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "catalog-page__title-wrap"
  }, [_c('div', {
    staticClass: "catalog-page__title"
  }, [_c('h1', {
    staticClass: "catalog-page__title-text h1 pr-7"
  }, [_vm._v("\n          " + _vm._s(_vm.data.title) + "\n        ")]), _vm._v(" "), _vm.getModelCount ? _c('div', {
    staticClass: "fz-13 lh-18",
    attrs: {
      "data-e2e": "product-count"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getModelCount) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm.data.isLargeЕquipment ? _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('InfoBlockLargeEquipment', {
          staticClass: "catalog-page__large-equipment"
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('InfoBlockLargeEquipment')];
      },
      proxy: true
    }], null, false, 1577769290)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "catalog-page__grid"
  }, [_vm.error ? _c('StatusBlock', {
    key: "error",
    attrs: {
      "size": "l",
      "type": "error"
    }
  }, [_c('div', {
    staticClass: "catalog-page__error"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("\n          Попробуйте обновить страницу, или воспользоваться страницей позднее\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "catalog-page__button"
  }, [_c('Button', {
    attrs: {
      "fluid": "",
      "size": "39",
      "theme": "white"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n            Обновить страницу\n          ")])], 1)])]) : _c('TSProductGrid', {
    attrs: {
      "quantity-on-page": 60,
      "loading": _vm.loading,
      "availability": _vm.availabilitySort,
      "filter-photo-row": _vm.data.filterPhotoRow,
      "product-list": _vm.list,
      "pagination": _vm.pagination,
      "sort-list": _vm.sortList,
      "active-sort": _vm.activeSort,
      "link-page": _vm.linkPage,
      "filter-first-row": _vm.data.filter.brand && _vm.data.filter.brand.list,
      "filter-first-row-value": _vm.data.filter.brand && _vm.data.filter.brand.value,
      "filter-second-row": _vm.data.filter.model && _vm.data.filter.model.list,
      "filter-second-row-value": _vm.data.filter.model && _vm.data.filter.model.value,
      "product-card-photo-lazyload": false,
      "row-photo-filter-photo-lazyload": false,
      "count-product-card-photo-no-lazyload": 20,
      "mobile-favorite-button": true,
      "filter-tag": "a",
      "list-name": "Каталог",
      "hide-sort": _vm.isBonusesPage,
      "hide-filter-row": _vm.isBonusesPage
    },
    on: {
      "change-page": function ($event) {
        _vm.emit('change-page', Number($event)), _vm.scrollTop();
      },
      "load-more": function ($event) {
        return _vm.emit('load-more', $event);
      },
      "sort": function ($event) {
        return _vm.emit('sort', $event);
      },
      "availability-change": function ($event) {
        return _vm.onAvailabilityChange(true, $event);
      },
      "filter-first-row-change": function ($event) {
        return _vm.onBrandFilterChange($event);
      },
      "filter-second-row-change": function ($event) {
        return _vm.onModelFilterChange($event);
      },
      "product-select": function ($event) {
        return _vm.emitter.emit('product-select', {
          index: $event.index,
          product: $event.product,
          listName: 'Каталог'
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('Note', {
          staticClass: "mt-15",
          attrs: {
            "size": "m"
          }
        }, [_c('h5', {
          staticClass: "h5 mb-8"
        }, [_vm._v("\n            Товары не найдены\n          ")]), _vm._v(" "), _c('p', {
          staticClass: "p mb-8"
        }, [_vm._v("\n            Попробуйте изменить значения фильтров или убрать некоторые из них.\n          ")]), _vm._v(" "), _c('Button', {
          attrs: {
            "theme": "white",
            "fluid": ""
          },
          on: {
            "click": _vm.resetFilter
          }
        }, [_vm._v("\n            Сбросить фильтры\n          ")])], 1)];
      },
      proxy: true
    }, {
      key: "headerMobileFilterButton",
      fn: function () {
        return [_c('div', {
          staticClass: "catalog-page__filter-button"
        }, [_c('FilterButton', {
          attrs: {
            "active": !!_vm.data.filter.main.groupValue.length && !_vm.loading,
            "is-filter-selected": !!_vm.data.filter.main.groupValue.length,
            "filters": _vm.data.filter.main.groupValue
          },
          on: {
            "show-filter-modal": function ($event) {
              _vm.activeFilterModal = true;
            },
            "reset": _vm.resetFilter
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "headerMobileFilter",
      fn: function (_ref) {
        var onSort = _ref.onSort,
            sortList = _ref.sortList,
            activeSort = _ref.activeSort,
            filterFirstRowValue = _ref.filterFirstRowValue,
            filterFirstRow = _ref.filterFirstRow,
            onFilterFirstRowChange = _ref.onFilterFirstRowChange,
            selectFilterPlaceholder = _ref.selectFilterPlaceholder;
        return [sortList.length ? _c('div', [_c('SortSelect', {
          attrs: {
            "list": sortList,
            "value": activeSort,
            "width": "96px"
          },
          on: {
            "change": onSort
          }
        })], 1) : _vm._e(), _vm._v(" "), filterFirstRow.length ? _c('div', [_c('SelectFilter', {
          attrs: {
            "placeholder": selectFilterPlaceholder,
            "value": filterFirstRowValue,
            "list": filterFirstRow,
            "icon": "arrow",
            "width": "116px"
          },
          on: {
            "change": onFilterFirstRowChange
          }
        })], 1) : _vm._e()];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }